<!--20-团队检票-->
<template>
  <div class="pm50">
    <div class="pd jhnstop row">
      <p class="col">
        <img src="../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome">首页</span>
    </div>

    <div class="jjnnjnsert">
      <van-search
        v-model="queryInput.queryText"
        show-action
        placeholder="请输入车牌号码/团队名称"
        @search="onSearch"
      >
        <template #action>
          <van-button type="primary" class="sfdgdfyyw" @click="onSearch"
            >搜索</van-button
          >
        </template>
      </van-search>
      <!-- <span class="ml20">检票区域：{{ groundName }}</span> -->
      <van-cell class="" title="检票区域：" :value="groundName||'请选择'" :value-class="queryInput.groundId?'z3':''" is-link @click="showGrounds=true" />
    </div>
    <no-data
      v-if="dataLoaded && orders.length === 0"
      :content-height="400"
    ></no-data>
    <van-list v-else v-model="loading" :finished="finished" @load="onLoad" class="dataDiv pd">
      <div
        class="pd ffdyyewr sdfsdtywer mt5 mb15 pm15"
        v-for="(order, index) in orders"
        :key="index"
      >
        <div class="fz16 z3 row pt10">
          <p class="col">{{ order.customerName }}</p>
          <span class="zts" v-if="order.hasCheckOut">已完成</span>
          <span class="zts" v-else-if="order.hasCheckIn">已入场</span>
          <span class="zts" v-else-if="!order.hasCheckIn">未入场</span>        
          
        </div>
        <div class="jjnmmnxer mt10 pt10">
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">单 号 </span>
            </span>
            <span class="ml10 fz14 z6">{{ order.listNo }}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">参观日期 </span>
            </span>
            <span class="ml10 fz14 z6">{{ order.travelDate }}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert" v-if="order.arrivalTime">讲解时间</span>
              <span class="kkmnmxerert" v-else>入馆时段</span>
            </span>
            <span class="ml10 fz14 z6" v-if="order.arrivalTime">{{ order.arrivalTime }}</span>
            <span class="ml10 fz14 z6" v-else>{{ order.changCiStime }}-{{ order.changCiEtime }}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">参观区域 </span>
            </span>
            <span class="ml10 fz14 z6">{{ order.ticketTypeName }}</span>
          </div>
          <div v-if="order.ageRanges.length === 0" class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">人数 </span>
            </span>
            <span class="ml10 fz14 z6">{{ order.totalNum }}人</span>
          </div>
          <div
            v-else
            v-for="(ageRange, index) in order.ageRanges"
            :key="index"
            class="mt10"
          >
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">{{ ageRange.ageRangeName }} </span>
            </span>
            <span class="ml10 fz14 z6">{{ ageRange.personNum }}人</span>
          </div>
          <div v-if="order.plateNumbers && order.plateNumbers.length>0" >
            <div class="mt10" v-for="(plateNumber, index) in order.plateNumbers" :key="index">
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">车牌号{{index+1}}</span>
              </span>
              <span class="ml10 fz14 z6">{{ plateNumber.licensePlateNumber }} {{ plateNumber.carTypeName }}</span>
            </div>
          </div>
          <div class="mt10 row">
            <div class="col">
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">客 源 </span>
              </span>
              <span class="ml10 fz14 z6" v-if="order.areaName">{{ order.keYuanTypeName + "," + order.areaName}}</span>
              <span class="ml10 fz14 z6" v-else-if="order.keYuanTypeName">{{ order.keYuanTypeName }}</span>
            </div>
            <!-- <van-button type="primary" class="fz12 dfgdfywer" v-if="0==0" >入场</van-button>
                         <van-button type="primary" class="fz12 dfgdfywer" v-if="0==1">出场</van-button> -->
            <van-button
              v-if="!parkCloseTime && !order.hasCheckOut"
              type="primary"
              class="fz12 dfgdfywer"
              :loading="loading && currentIndex === index"
              @click="onClick(index)"
              >{{ order.hasCheckIn ? "出场" : "入场" }}</van-button
            >
          </div>
        </div>
      </div>
    </van-list>
    <van-action-sheet
      v-model="showGrounds"
      :actions="grounds"
      @select="onGroundSelecter"
    />
  </div>
</template>
<script>
import moment from "moment";
import { mapState,mapActions } from "vuex";
import NoData from "@/components/NoData.vue";
import orderService from "@/services/orderService.js";
import appConsts from "@/store/consts.js";
import signalRHelper from "@/utils/signalRHelper.js";
import scenicService from "./../services/scenicService.js";
const connection = signalRHelper.buildCheckerNotificationConnection();

const today = moment().format("YYYY-MM-DD");

export default {
  data() {
    return {
      queryInput: {
        queryText: "",
        groundId: "",
        customerFlag: true,
        skipCount: 0,
        maxResultCount: 10,
      },
      loading: false,
      dataLoaded: false,
      finished: false,
      currentIndex: -1,
      orders: [],
      groundName: "",
      grounds: [],
      showGrounds: true,
      currentListNo: "",
    };
  },
  computed: {
    contentHeight() {
      return this.$store.state.clientHeight - 90;
    },
    ...mapState({
      options: (state) => state.orderModule.options
    }),
    parkCloseTime(){
      var ctime = moment().format("HH:mm");
      if(ctime>=this.options.parkCloseTime)
      {
          return true;
      }else{
        return false;
      }
    }
  },
  components: {
    NoData,
  },
  methods: {    
    async refreshOrder() {
      if (!this.currentListNo) {
        return;
      }
      let result = await orderService.getGroupOrdersForConsumeShouldPageAsync({QueryText:this.queryText,GroundId:this.queryInput.groundId, CustomerFlag:true,ShouldPage: false,ListNo:this.currentListNo});
      const order = result.items[0];
      let originalOrder = this.orders.filter(
        o => o.listNo == this.currentListNo
      )[0];
      originalOrder.hasCheckIn = order.hasCheckIn;
      originalOrder.hasCheckOut = order.hasCheckOut;
    },
    async onLoad() {
      await this.loadOrdersAsync();
    },
    toHome() {
      this.$router.push("/");
    },
    async onGroundSelecter(item) {
      this.queryInput.groundId = item.value;
      this.groundName = item.name;
      this.showGrounds = false;
      await this.onSearch();
    },
    async onSearch(){
      this.orders = [];
      this.queryInput.skipCount = 0;
      await this.loadOrdersAsync();
    },
    async getGrounds() {
      this.wxLastBookTime = "";
      const grounds = await scenicService.getGroundComboboxItemsAsync({
        travelDate: today,
      });
      this.queryInput.groundId = "";
      this.grounds = grounds.map((g) => {
        return {
          value: g.value,
          name: g.displayText,
        };
      });
    },
    async onClick(index) {
      if (!this.queryInput.groundId) {
        this.$toast("请选择检票区域");
        this.showGrounds = true;
        return;
      }
      this.currentIndex = index;
      let order = this.orders[index];
      try {
        this.loading = true;
        if (!order.hasCheckIn) {
          await this.$dialog.confirm({
            title: "确定入场？",
          });
          await orderService.consumeOrderFromMobileAsync({ListNo:order.listNo,GroundId:this.queryInput.groundId});
        } else {
          await this.$dialog.confirm({
            title: "确定出场？",
          });
          await orderService.checkOutOrderFromMobileAsync({ListNo:order.listNo,GroundId:this.queryInput.groundId});
        }
        this.currentListNo=order.listNo;
      } catch (err) {
        return;
      } finally {
        await this.refreshOrder();
        this.loading = false;
      }
    },
    async loadOrdersAsync() {
      if (!this.queryInput.groundId) {
        this.$toast("请选择检票区域");
        this.showGrounds = true;
        return;
      }
      try {
        this.loading = true;
        this.dataLoaded = false;

        let result = await orderService.getGroupOrdersForConsumeShouldPageAsync(this.queryInput);
        result.items.forEach((order) => {
          if (order.checkInTime) {
            order.checkInTime = moment(order.checkInTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          if (order.checkOutTime) {
            order.checkOutTime = moment(order.checkOutTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          this.orders.push(order);
        });
        this.queryInput.skipCount = this.queryInput.skipCount + result.items.length;
        this.finished = this.orders.length === result.totalCount;
       } catch (err) {
        return;
      } finally {
        this.dataLoaded = true;
        this.loading = false;
      }
    },
    layzeLoadOrder() {
      //alert("layzeLoadOrder");
      setTimeout(this.loadOrdersAsync, 300);
    },
    ...mapActions("orderModule", [appConsts.loadOrderOptionsAsync]),
  },
  async created() {
    await this.getGrounds();

    await this.loadOrdersAsync();

    connection.on("CheckIn", this.layzeLoadOrder);
    connection.on("CheckOut", this.layzeLoadOrder);
    connection.start();
  },
  beforeDestroy() {
    connection.stop();
    connection.off("CheckIn");
    connection.off("CheckOut");
  },
  mounted() {},
};
</script>
<style scoped>
.dataDiv {
  overflow: auto;
  position: fixed;
  width: 100%;
  height: calc(100vh - 150px);
}
</style>
